/**
 * Created by Administrator on 2017/7/10.
 */
/* eslint-disable */
window.onload = function () {
  fuc1();
  // fuc2();
}
function fuc1() {
  var timer = null;
  //找人
  var box = document.getElementById("box-top");
  var screen = box.children[0];
  var ul = screen.children[0];
  var ulLis = ul.children;
  var ol = screen.children[1];
  var arr = document.getElementById("box-arr");
  var left = document.getElementById("box-left");
  var right = document.getElementById("box-right");
  var imgWidth = screen.offsetWidth;
  // alert(imgWidth);

  //主体逻辑： 写一个完整的轮播图 有按钮 有箭头 能无缝滚动 能自动播放
  let sliderWidth = box.clientWidth;
  for (let i = 0; i < ulLis.length; i++) {
    let child = ulLis[i]
    child.style.width = sliderWidth + 'px'
  }
  //1.动态生成结构

  //1.1动态生成按钮
  //按照ul中li的数量去生成按钮
  for (var i = 0; i < ulLis.length; i++) {
    var li = document.createElement("li");
    // li.innerHTML = i + 1;
    ol.appendChild(li);
  }
  var olLis = ol.children;
  olLis[0].className = "current";

  //1.2动态生成最后一张假图片图片
  //根据第一张真的图片去生成假的
  //克隆第一张
  var firstImg = ulLis[0].cloneNode(true);//深层复制 里面的东西都要
  //追加到ul里的最后
  ul.appendChild(firstImg);

  //2.鼠标经过按钮
  //经过按钮后 按钮会排他 把 ul 移动到相应位置

  //2.1给所有的按钮绑定鼠标经过事件 事件中当前按钮高亮 其他的灭掉
  for (var j = 0; j < olLis.length; j++) {
    olLis[j].index = j;
    olLis[j].onmouseover = function () {
      //排他
      //干掉所有人
      for (var k = 0; k < olLis.length; k++) {
        olLis[k].className = "";
      }
      //留下我自己
      this.className = "current";

      //2.2让ul移动到指定位置
      //目标target 和 当前按钮的索引有关 和 图片的宽度有关 而且是负数
      var target = -this.index * imgWidth;
      animate(ul, target);

      //6.2鼠标经过按钮的时候 除了要移动ul
      // 还要让记录当前显示图片的索引的pic 以及 记录当前亮起的按钮的索引的square
      // 让他们统一 成 当前按钮的索引
      //square = this.index;//让记录当前亮起的按钮的索引的square变为当前按钮的索引
      //pic = this.index;//图片也是
      pic = square = this.index;
    };
  }

  //3.鼠标点击箭头
  // 4.按钮也要跟着
  // 鼠标经过box 让arr 显示 离开隐藏
  box.onmouseover = function () {
    arr.style.display = "block";
    //还要清理自动播放的那个定时器
    clearInterval(timer);
  };
  box.onmouseout = function () {
    arr.style.display = "none";
    //鼠标离开后还应该继续滚
    timer = setInterval(playNext, 4000);
  };

  var pic = 0;//用来记录当前显示的图片的索引
  var square = 0;//用来记录当前亮起的按钮的索引
  //点击右箭头 移动ul到相应位置
  right.onclick = function () {
    //一进来先判断 当前显示的图片的索引是不是最后一个图片
    if (pic === ulLis.length - 1) {//如果是 最后的 首先瞬间跳回去 而且还要滚
      ul.style.left = 0 + "px";//瞬间跳回去
      pic = 0;//把记录当前显示的图片的索引归零
    }
    pic++;//计算出接下来要显示的图的索引
    //目标 target 和 pic有关 和 图片宽度有关 而且是负数
    var target = -pic * imgWidth;
    animate(ul, target);
    //点击右箭头的时候 按钮也要跟着变
    //判断一下 如果没有到最后一个按钮的索引 可以加
    //如果到了 就归零
    if (square < olLis.length - 1) {
      square++;
    } else {
      square = 0;
    }
    //排他
    //干掉所有人 让所有的按钮灭掉 也就是 干掉类名
    for (var i = 0; i < olLis.length; i++) {
      olLis[i].className = "";
    }
    //留下当前的 也就是square这个索引所对应的
    olLis[square].className = "current";

  };

  //点击左箭头 移动ul到相应位置
  left.onclick = function () {
    //一进来先判断 当前显示的图片的索引是不是第一个图片的索引
    if (pic === 0) {//如果是 第一个 首先瞬间跳到最后 而且还得滚
      ul.style.left = -(ulLis.length - 1) * imgWidth + "px";//瞬间跳回去
      pic = ulLis.length - 1;//把记录当前显示的图片的索引 变为最后的图片的索引
    }
    pic--;//计算出接下来要显示的图的索引
    //目标 target 和 pic有关 和 图片宽度有关 而且是负数
    var target = -pic * imgWidth;
    animate(ul, target);
    //点击左箭头的时候 按钮也要跟着变
    //判断一下 如果没有到第一个按钮的索引 可以减
    //如果到了 就变为最后的按钮的索引
    if (square > 0) {
      square--;
    } else {
      square = olLis.length - 1;
    }
    //排他
    //干掉所有人 让所有的按钮灭掉 也就是 干掉类名
    for (var i = 0; i < olLis.length; i++) {
      olLis[i].className = "";
    }
    //留下当前的 也就是square这个索引所对应的
    olLis[square].className = "current";
  };

  //5.添加自动滚动
  timer = setInterval(playNext, 4000);//每个一秒钟播放下一张
  function playNext() {
    right.onclick();
  }

  //6.最终完善 1鼠标经过的时候要停止播放

  function animate(obj, target) {
    clearInterval(obj.timer);
    obj.timer = setInterval(function () {
      var leader = obj.offsetLeft;
      var step = 55;
      step = leader < target ? step : -step;
      if (Math.abs(leader - target) >= Math.abs(step)) {
        leader = leader + step;
        obj.style.left = leader + "px";
      } else {
        clearInterval(obj.timer);
        obj.style.left = target + "px";
      }
    }, 8);
  }

}


function fuc2() {
  console.log(89898);
  var timer = null;
  var box = document.getElementById("box1");
  var screen = box.children[0];
  var ul = screen.children[0];
  var ulLis = ul.children;
  var ol = screen.children[1];
  var arr = document.getElementById("arr");
  var left = document.getElementById("left");
  var right = document.getElementById("right");
// var imgWidth = screen.offsetWidth;
  var imgWidth = 400;

  box.onmouseover = function () {
    arr.style.display = "block";
    clearInterval(timer);
  };
  box.onmouseout = function () {
    timer = setInterval(playNext, 2000);
  };

  var pic = 0;
  var square = 0;
  right.onclick = function () {
    console.log(66);
    if (pic === ulLis.length - 3) {
      document.getElementsByClassName('ces')[0].style.left = 0 + "px";
      pic = 0;
    }
    pic++;
    var target = -pic * imgWidth;
    animate(document.getElementsByClassName('ces')[0], target);
  };

  left.onclick = function () {
    if (pic === 0) {
      ul.style.left = -(ulLis.length - 1) * imgWidth + "px";
      pic = ulLis.length - 2;
    }
    pic--;
    var target = -pic * imgWidth;
    animate(ul, target);
    if (square > 0) {
      square--;
    } else {
      // square = olLis.length - 1;
    }
  };

//添加自动滚动
  timer = setInterval(playNext, 2000);
  function playNext() {
    right.onclick();
  }

  function animate(obj, target) {
    clearInterval(obj.timer);
    obj.timer = setInterval(function () {
      var leader = Number(obj.style.left.replace('px',''));
      var step = 25;
      step = leader < target ? step : -step;
      if (Math.abs(leader - target) >= Math.abs(step)) {
        leader = leader + step;
        obj.style.left = leader + "px";
      } else {
        clearInterval(obj.timer);
        obj.style.left = target + "px";
      }
    }, 15);
  }

}







// WEBPACK FOOTER //
// ./src/lib/bannerPic.js